<template>
  <div class="reset">
    <h1 class="title">Set you password</h1>
    <form class="reset-form" @submit.prevent="reset">
      <TextInput class="text-input"
                 label="New oassword"
                 placeholder="New password"
                 type="password"
                 v-model:value="password"
                 :error="passwordError"
      />
      <TextInput class="text-input"
                 label="Repeat new password"
                 placeholder="Repeat new password"
                 type="password"
                 v-model:value="password2"
                 :error="passwordError"
      />
      <Button class="button" type="submit">
        <template v-slot:icon-right>
          <ArrowRight/>
        </template>
        Set your password
      </Button>
    </form>

    <router-link to="/login">
      <TextButton class="text-button" dark>I already have an account</TextButton>
    </router-link>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Button, Checkbox, TextButton, TextInput} from "@timenaut/timenaut-vue-common"
import axios from 'axios';
import ArrowRight from "@timenaut/timenaut-vue-common/lib/assets/icons/feather/arrow-right.svg"
import {router} from "@/router";

@Options({
  components: {
    TextInput,
    Button,
    TextButton,
    Checkbox,
    ArrowRight,
  },
})
export default class extends Vue {
  password: string = "";
  password2: string = "";

  passwordError: string = "";

  async reset() {
    this.passwordError = "";

    console.log()

    if (this.password !== this.password2) {
      this.passwordError = "Passwords do not match";
      return;
    }

    if (this.password.length < 8) {
      this.passwordError = "Password must be longer than 8 characters";
      return;
    }

    axios.post(process.env.VUE_APP_API_URL + "/auth/reset", {
      password: this.password,
      resetCode: this.$route.hash,
    })
        .then(() => {
          router.push("/login");
        })
        .catch(() => {
          this.passwordError = "Unexpected error occurred"
        })
  }
}
</script>
<style scoped>
.reset {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: #16056B;
}

.reset-form {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
}

.text-input {
  margin: 12px 0;
  width: 320px;
}

.text-button {
  margin: 16px;
}

a {
  color: #16056B;
  text-decoration: underline;
}

.button {
  align-self: center;
  width: 280px;
}
</style>
